import { Alert, Circle } from '@mm/components';
import { QuestionCircleIcon } from '@mm/icons';
import React from 'react';
import { PrimaryToolTip } from '../../../common/components/PrimaryToolTip/PrimaryToolTip';
import './KeywordsProTips.scss';

type Props = {
  setAlertVisible: (visible: boolean) => void;
};

export const KeywordsProTips = (props: Props) => {
  const { setAlertVisible } = props;

  const renderToolTip = (
    replyTerm: string,
    ph1?: string,
    ph2?: string,
    ph3?: string,
    ph4?: string,
  ) => {
    return (
      <PrimaryToolTip
        classNameTitle="pro-tips__tooltip-title"
        classNameContainer="pro-tips__icon-tooltip"
        classNameArrow="pro-tips__tooltip-arrow"
        position="right"
        withoutLine
        useHover
        anchorElement={
          <QuestionCircleIcon className="pro-tips__info-icon" color="blue" />
        }
        title="Example"
      >
        In conversation with the bot user replies: <strong>{replyTerm}</strong>
        <ul style={{ marginTop: '10px' }} className="pro-tips__tooltip-list">
          <strong>Matching Q&A Keywords</strong>
          {ph1 && <li className="pro-tips__tooltip-list-item">{ph1}</li>}
          {ph2 && <li className="pro-tips__tooltip-list-item">{ph2}</li>}
        </ul>
        <ul className="pro-tips__tooltip-list">
          <strong>Not Matching Q&A Keyword</strong>
          {ph3 && <li className="pro-tips__tooltip-list-item">{ph3}</li>}
          {ph4 && <li className="pro-tips__tooltip-list-item">{ph4}</li>}
        </ul>
      </PrimaryToolTip>
    );
  };

  return (
    <Alert
      type="info"
      css={{ text: 'pro-tips__text-wrapper' }}
      className="pro-tips"
      closeIconProps={{
        className: 'pro-tips__close-icon',
        onClick: () => setAlertVisible(false),
      }}
    >
      <strong>Pro Tips:</strong>
      <div>
        <div className="pro-tips__item">
          <div className="pro-tips__item-description">
            <Circle
              color="var(--color-blue)"
              className="pro-tips__item-circle"
            />
            <span className="pro-tips__item-text">
              Put <strong>&quot;quotes&quot;</strong> around your keywords to
              use <strong>phrase match</strong> (bot will trigger the Q&A only
              when the user's response contains the terms in your keyword, in
              the right order).
            </span>
          </div>
          {renderToolTip(
            'book a table',
            '"I want to book a table"',
            '"can I book a table"',
            '"book table"',
            '"table booking"',
          )}
        </div>
        <div className="pro-tips__item">
          <div className="pro-tips__item-description">
            <Circle
              color="var(--color-blue)"
              className="pro-tips__item-circle"
            />
            <span className="pro-tips__item-text">
              Put <strong>[brackets] </strong>around your keywords when you want
              to use <strong>exact match</strong> (bot will trigger the Q&A only
              when the user’s response matches the keyword exactly).
            </span>
          </div>
          {renderToolTip(
            'book a table',
            '[book a table]',
            '',
            '[I want to book a table]',
            '[can I book a table]',
          )}
        </div>
        <div className="pro-tips__item">
          <div className="pro-tips__item-description">
            <Circle
              color="var(--color-blue)"
              className="pro-tips__item-circle"
            />
            <span className="pro-tips__item-text">
              Add keywords without wrap when you want to use{' '}
              <strong>broad match </strong>(bot will trigger the Q&A if any part
              of the keyword is found within the user phrase).
            </span>
          </div>
          {renderToolTip(
            'book a table',
            'table, book, booking',
            'I want to book something',
            'Any phrase that does not contain mentioned keywords',
          )}
        </div>
        <div className="pro-tips__item">
          <div className="pro-tips__item-description">
            <Circle
              color="var(--color-blue)"
              className="pro-tips__item-circle"
            />
            <span className="pro-tips__item-text">
              Q&A Keywords are never case sensitive
            </span>
          </div>
        </div>
      </div>
    </Alert>
  );
};
